type UserType = {
  profilePicture?: string | null;
  name?: string | null;
};

export const extractAvatars = (participants?: Pick<UserType, 'name' | 'profilePicture'>[] | null) =>
  participants?.map((participant) => ({
    src: participant?.profilePicture || '',
    name: participant?.name || '',
  })) || [];

export const extractAvatarsFromArray = (participants: string[]) =>
  participants.map((participant) => ({
    src: participant || '',
    name: participant || '',
  }));
